import { Card, CardContent, Container } from '@packages/shared';
import { ComponentRecognizer } from '../../components/ComponentRecognizer/ComponentRecognizer';
import type { CmsData } from '../../../interfaces/webapp_json';
import { registerFlexibleComponents } from '../../components/ComponentRecognizer/registerFlexibleComponents';

// register the dynamic components
registerFlexibleComponents();

export type ServiceLayerFallbackProps = {
  /** json data used to render banner */
  serviceLayerData: CmsData;
};

/**
 * This component displays Service Layer Content on Product Detailview Pages
 *
 * @param serviceLayerData Object contains data
 * @returns JSX.Element to be placed in PageLayout
 */
const ServiceLayerFallback = ({ serviceLayerData }: ServiceLayerFallbackProps): JSX.Element => (
  <Container
    maxWidth="md"
    sx={{
      padding: 2,
    }}
  >
    <Card sx={{ minWidth: 275 }}>
      <CardContent>
        {serviceLayerData.paragraph.map(
          (item, index): JSX.Element =>
            item && (
              // The unique key is important from a performance point of view so that React doesn't have to render everything.
              // In this case it doesn't matter if only index or key is passed. The list is as it is and done.
              // eslint-disable-next-line react/no-array-index-key
              <ComponentRecognizer key={index} item={item} />
            ),
        )}
      </CardContent>
    </Card>
  </Container>
);

// eslint-disable-next-line import/no-default-export
export default ServiceLayerFallback;
